import { useQuery, useQueryClient } from '@tanstack/react-query';

import { UserConnections } from '../types/networking';
import { apiMain } from 'services/apiService';

export function useUserConnections(userId: string, loggedUserId: string) {
  const queryClient = useQueryClient();
  const isDev = process.env.NODE_ENV === 'development';

  const { data, isLoading, error } = useQuery<UserConnections, Error>({
    queryKey: ['userConnections', loggedUserId, userId],
    queryFn: async () => {
      if (isDev) {
        console.log('[useUserConnections] userId', userId);
        console.log('[useUserConnections] loggedUserId', loggedUserId);
      }
      const res = await apiMain.get<UserConnections>(
        `/networking/v1/stats/connection/${loggedUserId}/${userId}`
      );
      return res.data;
    },
    enabled: !!userId && !!loggedUserId,
    staleTime: 1000 * 60, // 1 minute
  });

  const refresh = () => {
    queryClient.invalidateQueries({ queryKey: ['userConnections', loggedUserId, userId] });
  };

  return {
    connections: data || null,
    loading: isLoading,
    error: error?.message || null,
    refresh,
  };
}
